// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .chatHead {
    height: 24.5vw;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(208, 208, 208, 0.25);
    display: flex;
    flex-direction: row;
    justify-content: initial;
    align-items: center;
}

.chatHead_img {
    width: 18vw;
    height: 18vw;
    margin: 0 5vw 0 6.5vw;
    object-fit: contain;
}

.chatHead_title_p {
    margin: 0;
}

.chatHead_title_status {
    margin: 0.5vw 0 0 0;
}

.chatHead_Italics {
    font-style: italic;
} */


.chatHead {
    height: 9vh;
    position: fixed;
    top: 0;
    left: 0;
    width: 90%;
    z-index: 1000; /* Adjust z-index as needed */
    padding: 0 5%;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(208, 208, 208, 0.25);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;


}
/* .chatHead_icn {
    height: 9vh;
    padding: 0 5%;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(208, 208, 208, 0.25);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
} */
.chatHead_title{
    height: 8vh;
    background: #cefad0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}
.chatHead_img {
    width: 18vw;
    height: 18vw;
    margin: 0 5vw 0 6.5vw;
    object-fit: contain;
}

.chatHead_title_p {
    margin: 0;
}

.chatHead_title_status {
    margin: 0.5vw 0 0 0;
}

.chatHead_Italics {
    font-style: italic;
}

.g20_img{
    height: 7.5vh;
    object-fit: contain;

}

.gov_img {
    height: 7vh;
    object-fit: contain;
}

.chatHead_title_p1{
    font-size: 2.25vh;
    letter-spacing: 0.09rem;
    color: #7C7C7C;
}

.chatHead_title_p2{
    font-size: 3.25vh;
    letter-spacing: 0.09rem;
}`, "",{"version":3,"sources":["webpack://./src/components/form/formChat/chatHead/styles.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;;AAGH;IACI,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,UAAU;IACV,aAAa,EAAE,6BAA6B;IAC5C,aAAa;IACb,yBAAyB;IACzB,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;;AAGvB;AACA;;;;;;;;;GASG;AACH;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B","sourcesContent":["/* .chatHead {\n    height: 24.5vw;\n    background-color: #FFFFFF;\n    box-shadow: 0px 4px 4px rgba(208, 208, 208, 0.25);\n    display: flex;\n    flex-direction: row;\n    justify-content: initial;\n    align-items: center;\n}\n\n.chatHead_img {\n    width: 18vw;\n    height: 18vw;\n    margin: 0 5vw 0 6.5vw;\n    object-fit: contain;\n}\n\n.chatHead_title_p {\n    margin: 0;\n}\n\n.chatHead_title_status {\n    margin: 0.5vw 0 0 0;\n}\n\n.chatHead_Italics {\n    font-style: italic;\n} */\n\n\n.chatHead {\n    height: 9vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 90%;\n    z-index: 1000; /* Adjust z-index as needed */\n    padding: 0 5%;\n    background-color: #FFFFFF;\n    box-shadow: 0px 4px 4px rgba(208, 208, 208, 0.25);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n\n}\n/* .chatHead_icn {\n    height: 9vh;\n    padding: 0 5%;\n    background-color: #FFFFFF;\n    box-shadow: 0px 4px 4px rgba(208, 208, 208, 0.25);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n} */\n.chatHead_title{\n    height: 8vh;\n    background: #cefad0;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n}\n.chatHead_img {\n    width: 18vw;\n    height: 18vw;\n    margin: 0 5vw 0 6.5vw;\n    object-fit: contain;\n}\n\n.chatHead_title_p {\n    margin: 0;\n}\n\n.chatHead_title_status {\n    margin: 0.5vw 0 0 0;\n}\n\n.chatHead_Italics {\n    font-style: italic;\n}\n\n.g20_img{\n    height: 7.5vh;\n    object-fit: contain;\n\n}\n\n.gov_img {\n    height: 7vh;\n    object-fit: contain;\n}\n\n.chatHead_title_p1{\n    font-size: 2.25vh;\n    letter-spacing: 0.09rem;\n    color: #7C7C7C;\n}\n\n.chatHead_title_p2{\n    font-size: 3.25vh;\n    letter-spacing: 0.09rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
